<div class="tile">
        <div class="row">
        <div class="sm-5">
                <p>ICT Test Results Summary</p>
            <div style="text-align: center;margin-top: 50px;" class="donutchart assICTResultsChart" >
               
                
            </div>
            <hr>
            <div class="content" style="text-align: center;">
                   <div class="labels"> 
                       <div class="count">060</div>  <div class="hint">Passed (A to C)</div>
                    </div>                
                   <div class="labels">
                        <div class="count">030</div>  <span class="hint" >Low Pass (D to E)</span>
                    </div>
                   <div class="labels">
                        <div class="count">030</div>  <span class="hint">Failed (Below E)</span>
                    </div>
                </div>
               
        </div>
        
        <div class="sm-5 verticalLine" style="margin-left: 20px;">
                
              <div style="width:573px;margin-left: 20px;">
                    <div class="header">
                      <div class="left">
                        <div class="" style="font-size: 13px;">App Use Detail</div>
                       
                      </div>
                      <div class="right">
                        <div style="width: 15px;margin-left: 64px;margin-top:-1px;">
                          <div class="dropdown more" data-type="click">
                              <button class="btn clickable"><i class="icon icon-more"></i></button>
                              <div class="menu right">
                                <div class="item" tabindex="0">Export Panel Data(csv)</div>
                                <div class="item" tabindex="0">Export Panel Graphic(pdf)</div>
                                <hr>
                                <div class="item space-between">
                                  <div>Settings</div>
                                  <div><i class="icon icon-settings"></i></div>
                                </div>
                              </div>
                            </div>
                      </div>
                          </div>
                    </div>
                    <div class="content" style="display: inline-block;">
                            <table class="table dashed" style="width:550px;margin-left: 10px;">
                                    <thead style="color: #f2f2f2;">
                                      <tr>
                                        <th>Grade</th>
                                        <th>Students</th>
                                       
                                        <th>% of Tests Taken</th>
                                      </tr>
                                    </thead>
                                    <tbody style="background-color: black; font-size:12px;">
                                      <tr *ngFor=" let item of sumofAssessmentItems">
                                        <td><span style="margin-right:5px;color:#f78521;"><i class="icon icon-alarm-level5"></i></span>{{item.name}}</td>
                                        
                                        <td>{{item.students}}( {{item.gradecategory}})</td>
                                        <td><div class="progress-bar thin">
                                                <progress value="21" max="100"></progress>
                                                <span>21%</span>
                                            </div></td>
                                      </tr>
                                     
                                    </tbody>
                                  </table>
                      
                    </div>
                    
                  </div>
    
                  
    
        </div>
       
    </div>
    </div>

  